module.exports = __webpack_public_path__ + "static/media/EnergyDiagram3.98618c72.svg";